import { Button, mergeClassName } from '@chain-zen/ui'

import type { TActiveAssetType } from '../../hooks/use-eld-asset-selection'

const TAB_STYLES: Record<TActiveAssetType, { active: string; icon: string }> = {
  trailer: {
    active: 'bg-amber-500/20 text-amber-400 border border-amber-500/30',
    icon: '🚛'
  },
  truck: {
    active: 'bg-blue-500/20 text-blue-400 border border-blue-500/30',
    icon: '🚚'
  }
}

interface IAssetTypeTabProps {
  activeAssetType: TActiveAssetType
  currentValue?: string | null
  label: string
  onSelect: () => void
  tabKey: TActiveAssetType
}

/**
 * Tab button for switching between trailer and truck asset types.
 */
export const AssetTypeTab = ({ activeAssetType, currentValue, label, onSelect, tabKey }: IAssetTypeTabProps) => {
  const isActive = activeAssetType === tabKey
  const styles = TAB_STYLES[tabKey]
  const inactiveClasses = 'bg-muted text-muted-foreground border border-transparent hover:text-foreground'

  return (
    <Button
      variant="ghost"
      className={mergeClassName(
        'flex-1 px-3 py-2.5 h-auto text-sm font-medium transition-all flex items-center justify-center gap-2',
        isActive ? styles.active : inactiveClasses
      )}
      onClick={onSelect}
    >
      <span>{styles.icon}</span>
      <span>{label}</span>
      {!!currentValue && <span className="text-xs opacity-70">({currentValue})</span>}
    </Button>
  )
}
